/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ArticleStatus } from '../enums/article-status.enum';
import { ArticleSpecificInformationDto } from './article-specific-information-dto';
import { ArticleAttachedDocumentDto } from './article-attached-document-dto';
import { ArticleTaxDto } from './article-tax-dto';

export class ArticleDto {
  public id: string = undefined;
  public customerCompanyId: string = undefined;
  public articleNumber: string = undefined;
  public articleDescription: string = undefined;
  public statnrSe: string = undefined;
  public statnrNo: string = undefined;
  public additionalCode1: string = undefined;
  public additionalCode2: string = undefined;
  public additionalCode3: string = undefined;
  public description: string = undefined;
  public originCountryCode: string = undefined;
  public statusFlags: ArticleStatus;
  public specificInformation: ArticleSpecificInformationDto[];
  public attachedDocuments: ArticleAttachedDocumentDto[];
  public taxes: ArticleTaxDto[];

  //<custom-body>
  public constructor(source: ArticleDto) {
      Object.assign(this, source);
    }
  //</custom-body>
}
